import { useState, useEffect } from "react";

import { css } from "@compiled/react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { useAnalyticsClient } from "@/analytics/wac-analytics";
import JiraSoftwareNav from "@/templates/software/jira/sections/nav-bar/software-jira-navbar";

import { experiments, useExperimentExposure } from "../../../utils/experiment";
import { PaidJiraAiBackground } from "../sections/cfind-4666-frictionless-first-look/paid-jira-ai-background";
import { PaidJiraAiBody } from "../sections/cfind-4666-frictionless-first-look/paid-jira-ai-body";
import { PaidJiraAiDisclaimer } from "../sections/cfind-4666-frictionless-first-look/paid-jira-ai-disclaimer";
import { PaidJiraAiHeader } from "../sections/cfind-4666-frictionless-first-look/paid-jira-ai-header";
import { PaidJiraAiPreviewModal } from "../sections/cfind-4666-frictionless-first-look/paid-jira-ai-preview-modal";
import { PaidJiraAiTeamTypeMadLibPrompt } from "../sections/cfind-4666-frictionless-first-look/paid-jira-ai-team-type-mad-lib-prompt";

import {
    JiraAiFFLProvider,
    useJiraAiFFL
} from "./hooks/use-jira-ai-ffl-context";

const promptContainerCss = css({
    marginBlockStart: "48px",
    padding: "0 60px",
    textAlign: "center"
});

export const JiraProductTourAiTemplateContent = () => {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const analyticsClient = useAnalyticsClient();
    const { cgsDataLoading } = useJiraAiFFL();
    const [jiraFflExposureFired, fireJiraFflExposure] = useExperimentExposure(
        experiments.cfind4666JiraFfl
    );

    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);

    useEffect(() => {
        if (!jiraFflExposureFired) {
            fireJiraFflExposure();
        }
    }, [jiraFflExposureFired, fireJiraFflExposure]);

    useEffect(() => {
        if (cgsDataLoading) {
            setIsPreviewModalOpen(true);
        }
    }, [cgsDataLoading]);

    useEffect(() => {
        if (!analyticsClient) {
            return; // be sure analyticsClient is available before firing event
        }
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "PaidLandingJiraAiTemplate",
            attributes: {
                flow: "paidLandingJiraAi"
            }
        }).fire();
    }, [analyticsClient, createAnalyticsEvent]);

    return (
        <main>
            <JiraSoftwareNav />
            <PaidJiraAiBackground />
            <PaidJiraAiHeader />
            <div css={promptContainerCss}>
                <PaidJiraAiTeamTypeMadLibPrompt />
            </div>
            <PaidJiraAiDisclaimer />
            {isPreviewModalOpen && (
                <PaidJiraAiPreviewModal
                    onClose={() => setIsPreviewModalOpen(false)}
                />
            )}
            <PaidJiraAiBody />
        </main>
    );
};

export const JiraProductTourAiTemplate = () => (
    <JiraAiFFLProvider>
        <JiraProductTourAiTemplateContent />
    </JiraAiFFLProvider>
);
